/* 4KP - scheda prodotto: due ritocchi.

   1. LE TAB NON DEVONO FAR SALTARE LA PAGINA
   Le tab sono radio nascoste governate dal CSS. Il difetto del meccanismo
   nativo e' che, cliccando la label, il browser sposta il focus sulla radio e
   trascina la pagina fin dove la radio si trova: il cliente clicca
   "Scheda tecnica" e si ritrova sbalzato in cima. Qui il click viene gestito
   a mano, cosi la pagina resta ferma dov'e'.

   2. LA BARRA IN BASSO MOSTRA NOME E CODICE
   Di suo la barra fissa stampa il titolo intero, che sui nostri prodotti
   finisce con "Compatibile con MARCA MODELLO" e viene troncato a meta' da
   tre puntini. Qui il titolo viene accorciato allo stesso modo della testata
   e sotto ci si mette il codice, che e' quello che il cliente confronta.
   Il codice non viene inventato: viene copiato da quello gia stampato nella
   testata della scheda.

   La barra parte invisibile e compare solo scorrendo, quindi il ritocco
   avviene prima che si veda: nessun lampeggio.

   Se il JavaScript non parte, le tab funzionano lo stesso (torna solo il
   salto) e la barra resta come la fa il tema. Niente si rompe. */
(function () {
  'use strict';

  var SEP = 'compatibile con';

  /* ---- 1. le tab ------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || typeof t.closest !== 'function') return;

    var label = t.closest('.kp-tabs__tab');
    if (!label) return;

    var id = label.getAttribute('for');
    if (!id) return;

    var input = document.getElementById(id);
    if (!input) return;

    e.preventDefault();
    input.checked = true;
  });

  /* ---- 2. la barra in basso -------------------------------------------- */
  function accorcia(testo) {
    if (!testo) return '';
    var i = testo.toLowerCase().indexOf(SEP);
    if (i <= 0) return testo.trim();
    return testo.slice(0, i).trim();
  }

  function sistemaBarra() {
    var titolo = document.querySelector('.sticky-add-to-cart__title');
    if (!titolo || titolo.dataset.kpFatto === '1') return;

    var breve = accorcia(titolo.textContent);
    if (breve) titolo.textContent = breve;

    /* il codice si copia da quello gia stampato nella testata */
    var fonte = document.querySelector('.kp-testata__codice');
    if (fonte && !document.querySelector('.sticky-add-to-cart__codice')) {
      var riga = document.createElement('p');
      riga.className = 'sticky-add-to-cart__codice';
      riga.textContent = fonte.textContent.trim();
      titolo.insertAdjacentElement('afterend', riga);
    }

    titolo.dataset.kpFatto = '1';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sistemaBarra);
  } else {
    sistemaBarra();
  }
  /* la barra viene ricostruita quando cambia variante: si ripassa */
  window.addEventListener('load', sistemaBarra);
})();